"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_FILE = exports.UNASSIGNED = exports.STOCK_MEDIA = exports.SOURCE_ROLE_SPEAKER = exports.SOURCE_ROLE_HOST = exports.SCREEN_PRESENTER = exports.S3SourceTypes = exports.PDF_FILE = exports.MEDIA = exports.MAX_CAMERA_COUNT = exports.IMAGE_FILE = exports.EMPTY_THUMBNAIL = exports.CAMERA_PRESENTER = exports.BANNER = exports.AUDIO_PRESENTER = exports.AUDIO_FILE = void 0;
var VIDEO_FILE = exports.VIDEO_FILE = 'videoFile';
var AUDIO_FILE = exports.AUDIO_FILE = 'audioFile';
var IMAGE_FILE = exports.IMAGE_FILE = 'imageFile';
var PDF_FILE = exports.PDF_FILE = 'pdfFile';
var CAMERA_PRESENTER = exports.CAMERA_PRESENTER = 'cameraPresenter';
var SCREEN_PRESENTER = exports.SCREEN_PRESENTER = 'screenPresenter';
var AUDIO_PRESENTER = exports.AUDIO_PRESENTER = 'audioPresenter';
var SOURCE_ROLE_HOST = exports.SOURCE_ROLE_HOST = 'host';
var SOURCE_ROLE_SPEAKER = exports.SOURCE_ROLE_SPEAKER = 'speaker';
var BANNER = exports.BANNER = 'banner';
var MEDIA = exports.MEDIA = 'media';
var UNASSIGNED = exports.UNASSIGNED = 'Unassigned';
var EMPTY_THUMBNAIL = exports.EMPTY_THUMBNAIL = 'EmptyThumbnail';
var STOCK_MEDIA = exports.STOCK_MEDIA = 'stockMedia';
var S3SourceTypes = exports.S3SourceTypes = [IMAGE_FILE, VIDEO_FILE, AUDIO_FILE, PDF_FILE];
var MAX_CAMERA_COUNT = exports.MAX_CAMERA_COUNT = 10;